import { Outlet } from 'react-router-dom';
import DocumentSubSidebar from '../components/document/DocumentSubSidebar';

// CHG-130 REQ-DHR-027: scope prop 도입
// - 'global': /documents/* — 메인 메뉴 진입 (기존 동작)
// - 'project': /projects/:projectId/documents/* — 프로젝트 상단탭 진입
export interface DocumentLayoutProps {
  scope?: 'global' | 'project';
  // scope='project' 일 때 sidebar/Outlet에 spaceId 주입
  spaceId?: string;
  projectName?: string;
}

export default function DocumentLayout({ scope = 'global', spaceId, projectName }: DocumentLayoutProps) {
  // CHG-130 REQ-DHR-027:
  // - 'global': AppLayout의 p-6 패딩을 -m-6로 뚫고 전체 화면 차지
  // - 'project': ProjectDetailPage의 Outlet 컨테이너(p-6 없음) 안에 그대로 배치 — 음수 마진 적용 시 상/좌가 잘림
  const isProjectScope = scope === 'project';
  // project: 사이드 패널을 카드처럼 보이도록 좌측에만 살짝 여백
  const className = isProjectScope ? 'flex h-full gap-3' : 'flex -m-6';
  const style: React.CSSProperties | undefined = isProjectScope
    ? undefined
    : { height: 'calc(100% + 48px)' };

  return (
    <div className={className} style={style}>
      <DocumentSubSidebar scope={scope} overrideSpaceId={spaceId} projectName={projectName} />
      <div className="flex-1 min-w-0">
        <Outlet context={{ scope, spaceId }} />
      </div>
    </div>
  );
}
